import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../libs/auth/auth.service';
import { GuideLanguage, GuideLanguageModalComponent } from './guide-language-modal/guide-language-modal.component';

type Guide = 'company' | 'photographer';

@Component({
	standalone: true,
	selector: 'bt-user-guides',
	templateUrl: './user-guides.component.html',
	styleUrls: ['./user-guides.component.scss']
})
export class UserGuidesComponent {
	readonly #authService = inject(AuthService);
	readonly #dialog = inject(MatDialog);

	// Il fotografo scarica solo la sua guida, la company entrambe
	get canDownloadCompanyGuide(): boolean {
		return !this.#authService.isPhotographer();
	}

	openGuideLanguageModal(guide: Guide): void {
		this.#dialog
			.open(GuideLanguageModalComponent)
			.afterClosed()
			.subscribe((language?: GuideLanguage) => {
				if (language) {
					this.downloadGuide(guide, language);
				}
			});
	}

	// Le guide PDF stanno in src/assets/guides con nome basic-studios-<guida>-<lingua>.pdf
	downloadGuide(guide: Guide, language: GuideLanguage): void {
		const fileName = `basic-studios-${guide}-${language}.pdf`;
		const link = document.createElement('a');
		link.href = `assets/guides/${fileName}`;
		link.download = fileName;
		link.click();
	}
}
